import React from 'react';
import { Link } from 'react-router-dom';
import './Policies.css';

const ShippingPolicy = () => {
  return (
    <div className="policy-page">
      <div className="container">
        <div className="policy-content">
          <h1>Shipping Policy</h1>

          <p className="policy-intro">
            At Pawkit, we are committed to delivering your pet food and supplies quickly and efficiently. 
            Here's everything you need to know about our shipping process:
          </p>

          <h2>Delivery Area</h2>
          <p>
            We currently deliver within select areas. Please check pincode serviceability 
            during checkout. We ensure timely delivery for all orders placed within our service area.
          </p>

          <h2>Shipping Partners</h2>
          <p>
            The orders for the user are shipped through registered domestic courier companies and/or speed 
            post only. We work with reliable delivery partners to ensure your orders reach you safely and 
            on time.
          </p>

          <h2>Processing & Delivery Time</h2>
          <p>
            Orders are shipped within 1 day from the date of the order and/or payment or as per the delivery 
            date agreed at the time of order confirmation and delivering of the shipment, subject to courier 
            company/post office norms.
          </p>

          <h2>Delivery Address</h2>
          <p>
            Delivery of all orders will be made to the address provided by the buyer at the time of purchase. 
            Please ensure your delivery address is accurate and complete to avoid any delays.
          </p>

          <h2>Delivery Confirmation</h2>
          <p>
            Delivery of our services will be confirmed on your email ID as specified at the time of registration.
          </p>

          <h2>Shipping Costs</h2>
          <p>
            If there are any shipping cost(s) levied by the seller or the Platform Owner (as the case be), 
            the same is not refundable. Free shipping is available on orders above ₹999.
          </p>

          <h2>Delays</h2>
          <p>
            Platform Owner shall not be liable for any delay in delivery by the courier company/postal authority. 
            In case of unforeseen circumstances or force majeure events, delivery times may be affected.
          </p>

          <div className="policy-summary">
            <h2>Quick Summary</h2>
            <table className="policy-table">
              <tbody>
                <tr>
                  <td>Delivery Area</td>
                  <td>Select areas (check pincode at checkout)</td>
                </tr>
                <tr>
                  <td>Delivery Promise</td>
                  <td>As soon as possible</td>
                </tr>
                <tr>
                  <td>Processing Time</td>
                  <td>Within 1 day</td>
                </tr>
                <tr>
                  <td>Free Shipping</td>
                  <td>Orders above ₹999</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h2>Contact Us</h2>
          <div className="contact-info">
            <p><strong>Company:</strong> Pawkit</p>
            <p><strong>Address:</strong> Pandepur Road, Varanasi, Uttar Pradesh - 221008</p>
            <p><strong>Email:</strong> <a href="mailto:support@pawkit.in">support@pawkit.in</a></p>
            <p><strong>Phone:</strong> <a href="tel:+916388777710">+91-6388777710</a></p>
            <p><strong>Contact Hours:</strong> Monday - Friday (9:00 AM - 6:00 PM)</p>
          </div>

          <div className="policy-links">
            <h3>Related Policies</h3>
            <ul>
              <li><Link to="/terms">Terms & Conditions</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/refund-policy">Refund & Cancellation Policy</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;
